(() => {
  const pushEvent = (event) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(event);
  };

  const slugify = (value) => {
    const slug = value
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

    return slug || 'section';
  };

  const trackBlogClick = (link) => {
    let destination = '';

    try {
      destination = new URL(link.href, window.location.origin).pathname;
    } catch (error) {
      return;
    }

    pushEvent({
      event: 'torva_blog_click',
      blog_area: link.dataset.blogArea,
      blog_action: link.dataset.blogAction,
      destination,
    });
  };

  const trackShare = (method) => {
    pushEvent({
      event: 'share',
      method,
      content_type: 'blog_article',
      item_id: window.location.pathname,
    });
  };

  const initClickTracking = () => {
    if (document.documentElement.dataset.torvaBlogTrackingReady === 'true') return;
    document.documentElement.dataset.torvaBlogTrackingReady = 'true';

    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-torva-blog-click]');
      if (!link) return;

      trackBlogClick(link);
    });
  };

  const initArticle = (root) => {
    if (root.dataset.torvaBlogReady === 'true') return;
    root.dataset.torvaBlogReady = 'true';

    const content = root.querySelector('[data-torva-blog-content]');
    const toc = root.querySelector('[data-torva-blog-toc]');
    const tocList = root.querySelector('[data-torva-blog-toc-list]');

    if (content && toc && tocList) {
      const headings = Array.from(content.querySelectorAll('h2, h3'));

      if (headings.length >= 3) {
        headings.forEach((heading, index) => {
          const headingId = heading.id || `${root.dataset.torvaBlogArticle}-${slugify(heading.textContent)}-${index + 1}`;
          heading.id = headingId;

          const item = document.createElement('li');
          item.className = heading.tagName.toLowerCase() === 'h3' ? 'is-subheading' : '';

          const link = document.createElement('a');
          link.href = `#${headingId}`;
          link.textContent = heading.textContent.trim();
          link.dataset.torvaBlogClick = '';
          link.dataset.blogArea = 'toc';
          link.dataset.blogAction = 'jump_to_section';

          item.appendChild(link);
          tocList.appendChild(item);
        });

        toc.hidden = false;
      }
    }

    const shareButton = root.querySelector('[data-torva-blog-share]');
    if (!shareButton) return;

    shareButton.addEventListener('click', async () => {
      const url = window.location.href;
      const title = document.title;
      const originalLabel = shareButton.dataset.shareLabel;

      try {
        if (navigator.share) {
          await navigator.share({ title, url });
          trackShare('native_share');
          return;
        }

        await navigator.clipboard.writeText(url);
        trackShare('copy_link');
        shareButton.textContent = shareButton.dataset.copiedLabel;
        window.setTimeout(() => {
          shareButton.textContent = originalLabel;
        }, 2200);
      } catch (error) {
        if (error && error.name === 'AbortError') return;
        window.prompt('Copy this link:', url);
      }
    });
  };

  const init = () => {
    initClickTracking();
    document.querySelectorAll('[data-torva-blog-article]').forEach(initArticle);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
